module.exports = __webpack_public_path__ + "img/across shoulders.dab71477.png";